import { useEffect } from 'react';
import { useUser } from '../api/auth';
import { Box, Spinner } from '@veracity/vui';
import { useNavigate  } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isLoading, isAuthenticated, login } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const justLoggedOut = sessionStorage.getItem('justLoggedOut');
      
      if (justLoggedOut) {
        sessionStorage.removeItem('justLoggedOut');
        navigate('/home');
      } else {
        const currentUrl = window.location.pathname + window.location.search;
        login(currentUrl);
      }
    }
  }, [isLoading, isAuthenticated, login]);

  if (isLoading) {
    return (
      <Box alignItems="center" justifyContent="center" minH={700}>
        <Spinner />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box alignItems="center" justifyContent="center" minH={700}>
        <Spinner />
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;